import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import './Card.scss';

function AppCard(props) {
    return (
        <div className="appcard">
            <div className="appcard-img" onClick={props.onClick}>
                <Card.Img variant="top" src={props.src} />
            </div>
            <div className="appcard-body">
                {props.children}
            </div>
        </div>
    );
}

export default AppCard;